import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink, RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AlertRecertificationComponent } from "./components/alert-recertification/alert-recertification.component";
import { AlertModule } from "../../../shared/components/alert/alert.module";
import { NotificationPanelComponent } from "./components/notification-panel/notification-panel.component";
import { NotificationsEffects } from "./state/notifications.effects";
import { notificationsReducer } from "./state/notifications.reducer";

@NgModule({
  declarations: [AlertRecertificationComponent, NotificationPanelComponent],
  imports: [
    CommonModule, 
    AlertModule,
    EffectsModule.forFeature([NotificationsEffects]),
    RouterLink, 
    RouterModule,
    StoreModule.forFeature("notifications", notificationsReducer),
  ],
  exports: [NotificationPanelComponent, AlertRecertificationComponent],
  providers: [{ provide: "locationObject", useValue: location }],
})
export class NotificationsModule { }
